import { render, staticRenderFns } from "./UserLevels.vue?vue&type=template&id=ba961ae2&"
import script from "./UserLevels.vue?vue&type=script&lang=js&"
export * from "./UserLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports